export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ListSubFamily.vue?vue&type=template&id=2273457a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/ListSubFamily.vue?vue&type=template&id=2273457a&scoped=true
// module id = 2132
// module chunks = 31